import _ from 'underscore';
import Promise from 'bluebird';

export const ViewName = {
  AssetsView: 'edit-video-assets-view',
  StyleView: 'edit-video-style-view',
  AudioView: 'edit-video-audio-view',
};

export const ViewTitle = {
  [ViewName.StyleView]: 'Video style guide',
  [ViewName.AudioView]: 'Audio',
};

export const ColorTypeEnum = {
  BackgroundColor: 'backgroundColor',
  TextColor: 'textColor',
};

export const shortHeadlineType = {
  TextOverlay: 'textOverlay',
  BusinessName: 'businessName',
};

const keyframeTemplateList = [
  {
    TemplateId: '00000001-0000-0000-0000-000000000000',
    TemplateName: 'Template 8 Scene 1',
    Version: '1.0',
    Width: 1280,
    Height: 720,
    TemplateFileName: 'template8_keyframe1.html',
    Image: [
      {
        AspectRatio: '16:9',
        MinHeight: 360,
      },
    ],
    Text: [
      {
        MaxLengthInChar: 20,
      },
      {
        MaxLengthInChar: 36,
      },
    ],
  },
  {
    TemplateId: '00000001-0000-0000-0000-000000000001',
    TemplateName: 'Template 8 Scene 2',
    Version: '1.0',
    Width: 1280,
    Height: 720,
    TemplateFileName: 'template8_keyframe2.html',
    Image: [
      {
        AspectRatio: '16:9',
        MinHeight: 360,
      },
    ],
    Text: [
      {
        MaxLengthInChar: 20,
      },
      {
        MaxLengthInChar: 36,
      },
    ],
  },
  {
    TemplateId: '00000001-0000-0000-0000-000000000002',
    TemplateName: 'Template 8 Scene 3',
    Version: '1.0',
    Width: 1280,
    Height: 720,
    TemplateFileName: 'template8_keyframe3.html',
    Image: [
      {
        AspectRatio: '16:9',
        MinHeight: 360,
      },
    ],
    Text: [
      {
        MaxLengthInChar: 25,
      },
      {
        MaxLengthInChar: 40,
      },
    ],
  },
];

const getActiveTemplate = templateId => _.findWhere(keyframeTemplateList, { TemplateId: templateId });

export const getTextSizeLimitation = (templateId) => {
  const activeTemplate = getActiveTemplate(templateId);
  if (activeTemplate && activeTemplate.Text) {
    return activeTemplate.Text.map(text => text.MaxLengthInChar);
  }
  return [];
};

export const getImageSizeLimitation = (templateId) => {
  const activeTemplate = getActiveTemplate(templateId);
  if (activeTemplate && activeTemplate.Image) {
    return activeTemplate.Image.map((image) => {
      const minHeight = image.MinHeight;
      const aspectRatio = image.AspectRatio.split(':');
      const minWidth = minHeight * (aspectRatio[0] / aspectRatio[1]);

      return [minWidth, minHeight];
    });
  }
  return [];
};

export const MaxBusinessNameLength = 25;

export const loadImagePromise = (src, mock) => {
  const image = new Image();
  image.src = src;
  return new Promise((resolve) => {
    image.onload = () => {
      // if the actual image is 404, it will return a placeholder image which width and height are 80
      // todo: investigate if there is a better way to handle this
      if (image.width === 80 && image.height === 80 && !mock) {
        resolve('failed');
      } else {
        resolve('success');
      }
    };
    image.onerror = () => {
      if (!mock) {
        resolve('failed');
      } else {
        resolve('success');
      }
    };
  });
};

export const maxVideoCount = 4; // max clip count generated for each image
